import { api } from "@/lib/api";

import type {
  CategoryBonusRule,
  CreateWorkspaceReq,
  NotificationSchedule,
  NotificationType,
  UpdateWorkspaceReq,
  UpsertCategoryBonusRuleReq,
  UpsertNotificationScheduleReq,
  Workspace,
  WorkspaceBranding,
  WorkspaceList,
} from "@artisancode/api-types";

export interface WorkspaceListParams {
  page?: number;
  per_page?: number;
  q?: string;
}

export const workspaceService = {
  list: (params?: WorkspaceListParams) =>
    api.get<WorkspaceList>(
      "/workspaces",
      params as Record<string, string | number | boolean | undefined>,
    ),

  create: (body: CreateWorkspaceReq) =>
    api.post<Workspace>("/workspaces", body),

  update: (id: string, body: UpdateWorkspaceReq) =>
    api.put<Workspace>(`/workspaces/${id}`, body),

  delete: (id: string) => api.del(`/workspaces/${id}`),

  branding: () => api.get<WorkspaceBranding>("/workspaces/branding"),

  getBonusRules: (id: string) =>
    api.get<CategoryBonusRule[]>(`/workspaces/${id}/bonus-rules`),

  updateBonusRules: (id: string, rules: UpsertCategoryBonusRuleReq[]) =>
    api.put<CategoryBonusRule[]>(`/workspaces/${id}/bonus-rules`, { rules }),

  getNotificationSchedule: (id: string, type: NotificationType) =>
    api.get<NotificationSchedule>(
      `/workspaces/${id}/notification-schedules/${type}`,
    ),

  updateNotificationSchedule: (
    id: string,
    type: NotificationType,
    body: UpsertNotificationScheduleReq,
  ) =>
    api.put<NotificationSchedule>(
      `/workspaces/${id}/notification-schedules/${type}`,
      body,
    ),
};
